import { Box } from '@mantine/core';

import { useGetColor } from 'hooks';

import type { IconPropsType } from './types';

export const SuccessIcon = ({
  color,
  size = 24,
  sx,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.85355 11.6464C9.65829 11.4512 9.34171 11.4512 9.14645 11.6464C8.95118 11.8417 8.95118 12.1583 9.14645 12.3536L9.85355 11.6464ZM11.5 14L11.1464 14.3536C11.2458 14.4529 11.3823 14.5059 11.5227 14.4995C11.663 14.4931 11.7942 14.428 11.8841 14.3201L11.5 14ZM15.2174 10.3201C15.3942 10.108 15.3656 9.79267 15.1534 9.61589C14.9413 9.43911 14.626 9.46777 14.4492 9.67991L15.2174 10.3201ZM20 12H20.5C20.5 7.30558 16.6944 3.5 12 3.5V4V4.5C16.1421 4.5 19.5 7.85786 19.5 12H20ZM12 4V3.5C7.30558 3.5 3.5 7.30558 3.5 12H4H4.5C4.5 7.85786 7.85786 4.5 12 4.5V4ZM4 12H3.5C3.5 16.6944 7.30558 20.5 12 20.5V20V19.5C7.85786 19.5 4.5 16.1421 4.5 12H4ZM12 20V20.5C16.6944 20.5 20.5 16.6944 20.5 12H20H19.5C19.5 16.1421 16.1421 19.5 12 19.5V20ZM9.5 12L9.14645 12.3536L11.1464 14.3536L11.5 14L11.8536 13.6464L9.85355 11.6464L9.5 12ZM11.5 14L11.8841 14.3201L15.2174 10.3201L14.8333 10L14.4492 9.67991L11.1159 13.6799L11.5 14Z"
        fill={iconColor}
      />
    </Box>
  );
};
